import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ArrowLeft from 'material-ui-icons/ChevronLeft';
import MenuIcon from 'material-ui-icons/Menu';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import { withStyles } from 'material-ui/styles';
import { HashRouter, Route } from 'react-router-dom';
import { oauthSessionAlive, getFEClientName } from '../services/serviceAPIHelper';
import { getUserInformation, logout, getUserLanguage } from '../components/Login/loginService';
import { checkAuthoritiesForPath, navigateToFirstAllowedUrl } from '../components/SideBar/menudataprovider';
import SideBar from '../components/SideBar/SideBar';
import _get from 'lodash.get';
import Breadcrumbs from '../ui/Breadcrumbs';
import { Button } from 'material-ui';
import translate from 'react-i18next/dist/commonjs/translate';
import { Typography } from 'material-ui';
import SearchTabs from './SearchTabs';
import { getCMSConfiguration, cmsParentHandler, getCMSHeader } from './cmsLib';

import { fetchMarkets, handleMarketChange, getMarketFromUserOrStorage } from '../components/MarketAPI';


//import CMS new pages
import Home from './Home';
import Preview from './Preview';
import Footer from './Footer';
import Landing from './Landing';
import News from './News';

//import old web pages
import Login from '../components/Login/Login';
import Results from '../components/Results/Results';
import Reservations from '../components/Reservations/Reservations';
import Invoices from '../components/Invoices/Invoices';
import UserView from '../components/User/UserView';
import Users from '../components/User/UsersView';
import HotelRoomDataPrint from '../components/Reservation/HotelRoomDataPrint';
import ReservationConfirmView from '../components/Reservation/ReservationConfirmView';
import ReservationView from '../components/Reservation/ReservationView';
import ReservationCancelView from '../components/Reservation/ReservationCancelView';
import ReservationModifyView from '../components/Reservation/Modification/ReservationModifyView';
import ReservationModifyConfirmView from '../components/Reservation/Modification/ReservationModifyConfirmView';
import AgencyView from '../components/Agency/AgencyView';

import PendingPayments from '../components/Payments/PendingPayments';

import SpecialDestinationView from '../components/SpecialDestinations/Table/SpecialDestinationView';

import PasswordReminder from '../components/PasswordReminder/PasswordReminder';
import ChangePassword from '../components/ChangePassword/ChangePassword';
import TokenGeneratorView from '../components/BackOffice/TokenGeneratorView';
import ResetPasswordView from '../components/BackOffice/ResetPasswordView';

import Noauth from '../components/Noauth/Noauth';
import TransfersResults from '../components/Transfers/TransfersResults';
import TransfersConfirmm from '../components/Transfers/TransfersConfirmm';
import NewsItem from './NewsItem';
import ISOCountryMenu from '../ui/ISOCountryMenu';
import swal from 'sweetalert';
import { handleSubmitFactory, getAvailabilityWithParams } from '../components/SearchContent/CommonFunctions';
import SearchForm from '../components/SearchContent/SearchForm';
import PaymentPendingReservations from '../components/Payments/PaymentPendingReservations';
import { setRightLanguage } from '../services/momentService';

const drawerWidth = 210;

const styles = theme => ({
    appBar: {
        width: 'calc(100%)',
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.palette.background.main,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    hide: {
        display: 'none',
    },
    drawerPaper: {
        whiteSpace: 'nowrap',
        height: '100%',
        minHeight: '200px',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        boxShadow: '0 0 14px 0 rgba(0, 0, 0, 1)',
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing.unit * 7,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing.unit * 7,
        },
    },
    toolbar: {
        display: 'flex',
        padding: '0px'
    },
    content: {
        flexGrow: 1,
        border: '1px solid green',
        padding: '2px'
    }
});

function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
class Index extends React.Component {
    static parentHandler;
    constructor(props) {
        super(props);
        this.cmsConfiguration = getCMSConfiguration();
        this.state = this.getInitialState();
        cmsParentHandler(this.childHandler);        
    }

    getInitialState = () => {
        const clientName = getFEClientName();
        let initState = {
            open: false,
            alive: false,
            ishome: this.getIsHome(),
            logoUrl: '',
            navLogo: '',
            anchor: 'left',
            currentPage: '',
            menuHeigth: 100,
            tabs: this.cmsConfiguration ? this.cmsConfiguration.tabs : [],
            customHeader: this.getCustomHeaderName(),
            markets: [],
            selectedMarket: {
                code: getMarketFromUserOrStorage(this),
                label: getMarketFromUserOrStorage(this)
            },
            language: getUserLanguage(),
            useMarket: clientName === 'B2BWebOlympia' || clientName === 'default',
        };
        return initState;
    }



    connectionChanged = async (event) => {
        if (typeof event.connected === 'undefined' || this.state === event.connected) {
            return;
        }
        await this.setState({ alive: event.connected }, async () => {
            if (window.location.href.indexOf('preview') !== -1) {
                return;
            }
            if (!event.connected && window.location.hash !== '#/' && window.location.href.indexOf('token/') === -1 && window.location.href.indexOf('userchangepassword') === -1) {
                /**
                 * Acá no queremos guardar esta url si está ingresando por deeplinking,
                 * Cuando el usuario no está logueado, produce un error y hay que eliminar la variable a mano en el storage.
                 */
                if ( !window.location.href.includes('results/hotelsparams/?hotelCode')) { // -> Deeplinking
                    localStorage.setItem('redirectTo', window.location.href);
                }
                window.location.replace('/');
            } else if (event.connected && window.location.href.indexOf('token/') !== -1) {
                await this.goingConnected();
            } else if (event.connected) {
                await this.goingConnected();
                if (window.location.hash === '#/') {
                    setTimeout(() => {
                        navigateToFirstAllowedUrl();
                    }, 800);
                }
                //si me conected y tengo token en la URL
            }
        });
    }

    goingConnected = async () => {
        this.cmsConfiguration = await getCMSConfiguration();
        this.currentUser = await getUserInformation();
        let state = this.state;
        let logourl = this.cmsConfiguration && this.cmsConfiguration.themming
            && this.cmsConfiguration.themming ? this.cmsConfiguration.themming.logoImageUrl : '';
        state.logoUrl = logourl;

        let user_icon = this.currentUser && this.currentUser.user_detail
            ? this.currentUser.user_detail.photo : '';

        state.language = getUserLanguage();
        state.navLogo = user_icon;
        const clientName = await getFEClientName();
        state.useMarket = clientName === 'B2BWebOlympia' || clientName === 'default';
        if (state.useMarket) {
            state.selectedMarket = {
                code: await getMarketFromUserOrStorage(this),
                label: await getMarketFromUserOrStorage(this)
            };
            await fetchMarkets(this, getUserLanguage());
        }
        this.setState(state);
    }

    checkMarket = async () => {
        let state = this.state;
        const clientName = await getFEClientName();
        state.useMarket = clientName === 'B2BWebOlympia' || clientName === 'default';
        if (state.useMarket) {
            state.selectedMarket = {
                code: await getMarketFromUserOrStorage(this),
                label: await getMarketFromUserOrStorage(this)
            };

            fetchMarkets(this, getUserLanguage());
        }
    }

    childHandler = async (child, props) => {
        //('>>>>>> Creating header for ' + capitalize(child) + 'Header');
        await this.setState({
            customHeader: capitalize(child) + 'Header',
            customHeaderProps: props,
        });
    }

    updateDimensions = async () => {
        let innerHeight = window.innerHeight - 1;
        await this.setState({ menuHeigth: innerHeight });
    }
    async componentDidMount() {
        window.addEventListener('connectionChange', this.connectionChanged, false);
        window.addEventListener('hashchange', this.checkHash, false);
        window.addEventListener('resize', this.updateDimensions, false);
        this.updateDimensions();
        let evv = new Event('connectionChange');
        evv.connected = oauthSessionAlive();
        window.dispatchEvent(evv);
        //this will discover headers and links and etc.
        await this.checkHash();
    }

    componentWillUnmount() {
        window.removeEventListener('connectionChange', this.connectionChanged, false);
        window.removeEventListener('hashchange', this.checkHash, false);
        window.removeEventListener('resize', this.updateDimensions, false);
    }

    getIsHome() {
        let hash = window.location.hash;
        //este es el unico caso que consideramos home
        return (hash.indexOf('#/search') !== -1 || hash === '#/');
    }
    checkHash = async () => {
        this.currentUser = getUserInformation();
        this.cmsConfiguration = getCMSConfiguration();

        let ishome = false;
        let state = { ishome: ishome, open: ishome };
        //esto es mas flojito que gago pero bueno.
        let page = window.location.hash.split('/')[1];
        page = page.replace(/\?.+/, '').trim();
        let ignoredpages = ['preview', 'noauth','search', '', 'results', 'hotels', 'exclusive', 'exclusive-nautalia', 'experience', 'token', 'transfers', 'passwordremind', 'userchangepassword'];
        //si no tengo usuario estoy deslogueado.
        if (!ignoredpages.includes(page) && this.currentUser) {
            let hasAccess = checkAuthoritiesForPath(this.cmsConfiguration.links, page);
            if (!hasAccess) {
                setTimeout(function () {
                    window.location.href = '/#/noauth/forpage=' + page;
                }, 500);
            }
        }


        let logourl = this.cmsConfiguration && this.cmsConfiguration.themming
            && this.cmsConfiguration.themming ? this.cmsConfiguration.themming.logoImageUrl : '';
        state.logoUrl = logourl;
        state.cmsConfiguration = this.cmsConfiguration;
        state.tabs = this.cmsConfiguration.tabs;
        state.currentPage = page;
        state.customHeader = this.getCustomHeaderName();
        state.customHeaderProps = null;
        await this.setState(state);

    };

    getCustomHeaderName() {
        let page = window.location.hash.split('/')[1];
        page = (page || '').replace(/\?.+/, '');
        let isNotHotelCard = window.location.href.indexOf('hotelcard') === -1;
        if ((page === 'search' || page === 'results') && isNotHotelCard) {
            return capitalize(page) + 'Header';
        }
        return '';
    }

    handleDrawerOpen = async () => {
        await this.setState({ open: true });
    };

    handleDrawerClose = async () => {
        await this.setState({ open: false });
    };

    handleDrawerToogle = async () => {
        await this.setState({ open: !this.state.open });
    };

    handleDrawerCloseFromMenu = () => {
        let ishome = this.getIsHome();
        if (!ishome) {
            this.handleDrawerClose();
        }
    };
    promptExit = async () => {
        let response = await swal({
            title: this.props.t('HOME.EXIT_MENU'),
            text: this.props.t('HOME.QUIT_MESSAGE'),
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        });
        if (response) {
            logout();
        }
    };

    onMarketChange = market => {
        handleMarketChange(this, market);
    };

    calculateHeight = () => {

        if ( this.state.currentPage !== 'search' ) {
            return 'unset';
        }
        /**
         * Aca debemos revisar si el widget 1 está activo, ya que al mostrase
         * debemos regresar un alto estático mayor a 505px. 660px es el tamaño destinado al widget 1.
         */
        const cmsConfig = JSON.parse(window.localStorage.getItem('cmsConfiguration'));
        const widget1Hidden = _get(cmsConfig, 'layout.widgets[0].hidden', false);

        return widget1Hidden ? '505px' : '700px';
    }

    render() {
        const { classes, t } = this.props;
        setRightLanguage();
        const menu = (<SideBar open={this.state.open} onToggle={this.handleDrawerCloseFromMenu} />);
        const drawer = (
            <Drawer
                variant="permanent"
                className='noPrint cmsSideBar'
                classes={{
                    paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
                }}
                open={this.state.open}>
                <div style={{ height: '32px', maxWidth: '100%' }}>
                    <img style={{ width: '100%' }} src={this.state.navLogo} alt="logo" />
                </div>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={this.handleDrawerToogle}>
                    {this.state.open ? <ArrowLeft /> : <MenuIcon />}
                </IconButton>
                {menu}
            </Drawer>
        );

        return (
            <HashRouter>
                {
                    this.state.alive ?
                        <div className={(this.state.open ? ' rootMenuOpened' : '')}>
                            {drawer}
                            <div className={'cmsPage' + (this.state.open ? ' menuOpened' : '')}>
                                <div className="cmsTopContainer noPrint" id="cmsImageContainer">
                                    <div className="cmsContainer"  style={{ height: this.calculateHeight()}}>
                                        <div className="cmsTopBar">
                                            <div className="cmsNavBar">
                                                <table width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <a style={{ cursor: 'pointer' }}
                                                                    onClick={() => {
                                                                        navigateToFirstAllowedUrl();
                                                                    }} className="cmsLogoButton">
                                                                    <img src={this.state.logoUrl} alt="Olympia logo" style={{ height: 'auto' }} />
                                                                </a>

                                                            </td> 
                                                            <td className="cmsUserNameText">
                                                                <Typography>{t('COMMON.WELCOME')}</Typography>
                                                                <Typography component="b" noWrap>{this.currentUser ? this.currentUser.user_detail.name : 'Guest'}</Typography>
                                                            </td>
                                                            {this.state.useMarket ?
                                                                <td className="cmsMarket">
                                                                    <Typography>{t('COMMON.MARKET')}</Typography>
                                                                    <ISOCountryMenu
                                                                        translation={t}
                                                                        selectedValue={this.state.selectedMarket.code}
                                                                        selectionChanged={this.onMarketChange}
                                                                        dataProvider={this.state.markets} />
                                                                </td>
                                                                : ''}
                                                            <td>
                                                                <Button onClick={this.promptExit} color="secondary">{t('HOME.EXIT_MENU')}</Button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div>
                                         <td style={{ width: '100%' }}>
                                                {this.state.currentPage === 'search' ? <SearchTabs tabs={this.state.tabs} />
                                                     : ''}
                                            </td>
                                        </div>

                                        <div className="cmsBreadCrumbs">
                                            <Breadcrumbs />
                                        </div>
                                        <div className="cmsHeader">
                                            {getCMSHeader(this.getCustomHeaderName(), this.state.customHeaderProps)}
                                        </div>
                                    </div>
                                </div>
                                <div className="cmsBody">
                                    <Route path="/search" exact={false} component={Home} />
                                    <Route path="/promotions" exact={true} component={Landing} />
                                    <Route path="/promotions/:indexPage" exact={true} component={Landing} />
                                    <Route path="/news" exact={true} component={News} />
                                    <Route path="/news/:indexPage" exact={true} component={NewsItem} />

                                    <Route path="/results/hotels/:requestCode" exact={true} render={({ match }) => { return <Results requestCode={match.params.requestCode} />; }} />
                                    <Route path="/results/hotelsparams" exact={true} render={({ match, location }) => { 

                                        // const requestCode = await getAvailabilityWithParams(location);
                                        return <Results location={location} />; 
                                        
                                        }} />
                                    <Route path="/results/exclusive/:requestCode" exact={true} render={({ match }) => { return <Results requestCode={match.params.requestCode} />; }} />
                                    <Route path="/results/exclusive-nautalia/:requestCode" exact={true} render={({ match }) => { return <Results requestCode={match.params.requestCode} />; }} />
                                    <Route path="/results/experience/:requestCode" exact={true} render={({ match }) => { return <Results requestCode={match.params.requestCode} />; }} />
                                    <Route path="/hotels/:code/reserve/:requestCode" exact={true} render={({ match, location }) => { return <ReservationConfirmView requestCode={match.params.requestCode} />; }} />
                                    <Route path="/hotels/:code/reserve/:requestCode/payment-confirm" exact={true} render={({ match, location }) => {
                                        const value = location.search;
                                        const index = value.indexOf('?h=') + 3; // Mejorar esto
                                        const hash = value.slice(index, value.length);

                                        return <ReservationConfirmView hotelCode={match.params.code} requestCode={match.params.requestCode} confirmPayment={true} paymentHash={hash} />;
                                    }} />
                                    <Route path="/hotels/:code/reserve/:requestCode/payment-error" exact={true} render={({ match, location }) => {
                                        const value = location.search;
                                        const index = value.indexOf('?h=') + 3; // Mejorar esto
                                        const hash = value.slice(index, value.length);
                                        return <ReservationConfirmView hotelCode={match.params.code} requestCode={match.params.requestCode} errorForPayment={true} paymentHash={hash} />;
                                    }} />
                                    <Route path="/hotels/reservations-pending-payments" exact={true} component={PaymentPendingReservations} />                                    

                                    <Route path="/exclusive/:code/reserve/:requestCode" exact={true} render={({ match }) => { return <ReservationConfirmView requestCode={match.params.requestCode} />; }} />
                                    <Route path="/exclusive-nautalia/:code/reserve/:requestCode" exact={true} render={({ match }) => { return <ReservationConfirmView requestCode={match.params.requestCode} />; }} />
                                    <Route path="/experience/:code/reserve/:requestCode" exact={true} render={({ match }) => { return <ReservationConfirmView requestCode={match.params.requestCode} />; }} />


                                    <Route path="/results/hotels/:requestCode/hotelcard/:hotelCode" exact={true} component={HotelRoomDataPrint} />

                                    <Route path="/bookings" exact={true} component={Reservations} />
                                    <Route path="/bookings/payment-confirm" exact={true} render={({ match, location }) => {
                                        const value = location.search;
                                        const index = value.indexOf('?h=') + 3; // Mejorar esto
                                        const hash = value.slice(index, value.length);

                                        return <Reservations confirmPayment={true} paymentHash={hash} />;
                                    }} />
                                    <Route path="/bookings/payment-error" exact={true} render={({ match, location }) => {
                                        const value = location.search;
                                        const index = value.indexOf('?h=') + 3; // Mejorar esto
                                        const hash = value.slice(index, value.length);
                                        return <Reservations errorForPayment={true} paymentHash={hash} />;
                                    }} />
                                    <Route path="/invoices" exact={true} component={Invoices} />

                                    <Route path="/results/transfers/:token" exact={true} render={({ match }) => { return <TransfersResults token={match.params.token} />; }} />
                                    <Route path="/transfers/:toto/valuation/:token" exact={true} component={TransfersConfirmm} />

                                    <Route path="/bookings/:requestCode" exact={true} render={({match, location}) => {
                                        return match.params.requestCode !== 'payment-confirm' && match.params.requestCode !== 'payment-error' ? <ReservationView /> : null;
                                    }} />
                                    <Route path="/bookings/:requestCode/view" component={ReservationView} exact={true} />
                                    <Route path="/bookings/:requestCode/cancel" component={ReservationCancelView} />
                                    <Route path="/bookings/:requestCode/modify" component={ReservationModifyView} />
                                    <Route path="/bookings/:requestCode/confirm" component={ReservationModifyConfirmView} />

                                    <Route path="/owndata" exact={true} component={UserView} />
                                    <Route path="/users" exact={true} component={Users} />
                                    <Route path="/agency" exact={true} component={AgencyView} />
                                    <Route path="/pending-payments" exact={true} component={PendingPayments} />

                                    <Route path="/especialdestinations" exact={false} render={() => { return <SpecialDestinationView type={'Eroski'} />; }} />
                                    <Route path="/especialdestinationsnautalia" exact={true} render={() => { return <SpecialDestinationView type={'Nautalia'} />; }} />
                                    <Route path="/tokengenerator"  exact={true} component={TokenGeneratorView} />
                                    <Route path="/passwordreset" exact={true} component={ResetPasswordView} />

                                    <Route path='/noauth' component={Noauth} />

                                    <Route path="/preview" exact={false} component={Preview} />
                                </div>
                                <div className="cmsFooter noPrint">
                                    <div className="cmsContainer">
                                        <Footer />
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div>
                            <Route path="/" exact={true} component={Login} />
                            <Route path="/login" exact={true} component={Login} />
                            <Route path="/token/:usertoken" exact={true} component={Login} />
                            <Route path='/noauth' component={Noauth} />
                            <Route path='/passwordremind' component={PasswordReminder} />
                            <Route path='/userchangepassword/:token' component={ChangePassword} />
                            <Route path="/preview" exact={false} component={Preview} />
                        </div>
                }
            </HashRouter>
        );
    }
}

Index.propTypes = {
    classes: PropTypes.object.isRequired
};
export default translate('translations')(withStyles(styles)(Index));


// WEBPACK FOOTER //
// ./src/cms/Index.js